"use client";

import { c as _c } from "react/compiler-runtime";
import { NodeIconTile } from "@/components/ui/node-icon-tile";
import { CARD_TILE_ICON_CLASS, CARD_TILE_INNER_CLASS, CARD_TILE_WRAP_CLASS, CardIconStrip } from "@/components/workflow/CardIconStrip";
import { useBrandCardIcons } from "@/hooks/useWorkflowCardIcons";
import type { CardIconSource } from "@/lib/workflow/cardIcons";
import { cn } from "@/lib/utils";
interface FallbackTile {
  id: string;
  name: string;
  description?: string;
}
interface WorkflowCardIconStripProps {
  /** Workflow or Template — anything with a `definition` (or pre-extracted connectors/chains). */
  source: CardIconSource;
  /** When no brand-backed icons resolve, render a single AI-generated NodeIconTile for this entity. */
  fallback?: FallbackTile;
  className?: string;
}

/**
 * Data-fetching wrapper around `CardIconStrip`: resolves the workflow/template
 * catalog data, keeps only brand-backed icons (drops generic AI-only nodes),
 * and falls back to a single AI-generated NodeIconTile when nothing visual
 * resolves.
 */
export function WorkflowCardIconStrip(t0) {
  const $ = _c(16);
  const {
    source,
    fallback,
    className
  } = t0;
  const {
    brandIcons,
    triggers,
    actions,
    connectorTypes,
    chainInfoMap
  } = useBrandCardIcons(source);
  if (brandIcons.length === 0 && fallback) {
    let t1;
    if ($[0] !== className) {
      t1 = cn("flex items-center justify-center", className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = fallback.description ?? "";
    let t3;
    if ($[2] !== fallback.id || $[3] !== fallback.name || $[4] !== t2) {
      t3 = <NodeIconTile size="md" id={fallback.id} subject={fallback.name} context={t2} template="b3os-app-flat" alt={fallback.name} wrapClassName={CARD_TILE_WRAP_CLASS} innerClassName={CARD_TILE_INNER_CLASS} iconClassName={CARD_TILE_ICON_CLASS} />;
      $[2] = fallback.id;
      $[3] = fallback.name;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t1 || $[7] !== t3) {
      t4 = <div className={t1}>{t3}</div>;
      $[6] = t1;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  let t1;
  if ($[9] !== actions || $[10] !== brandIcons || $[11] !== chainInfoMap || $[12] !== className || $[13] !== connectorTypes || $[14] !== triggers) {
    t1 = <CardIconStrip icons={brandIcons} triggers={triggers} actions={actions} connectorTypes={connectorTypes} chainInfoMap={chainInfoMap} className={className} />;
    $[9] = actions;
    $[10] = brandIcons;
    $[11] = chainInfoMap;
    $[12] = className;
    $[13] = connectorTypes;
    $[14] = triggers;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  return t1;
}